export const SUCCESS = "ALERT_SUCCESS";
export const ERROR = "ALERT_ERROR";
export const CLEAR = "ALERT_CLEAR";
export const MULTIPLE = "ALERT_MULTIPLE";
